import InventoryEditPictures from './InventoryEditPictures'
export default InventoryEditPictures
